<i18n lang='yml' src='../i18n/HistoryTab.yml'></i18n>
<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <span id="historyTableTitle"> {{$t('history_of_events')}}</span>
    </div>
    <scroll-shadow>
      <div class="table-container" id="table-container-history" role="table" aria-describedby="historyTableTitle">
          <div class="flex-table-history" role="rowgroup">
          <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('edit_date') }}</div>
          <div class="flex-row table-header" role="columnheader">{{ $t('user') }}</div>
          <div class="flex-row flex-row-long table-header" role="columnheader">{{ $t('sponsor') }}</div>
          <div class="flex-row table-header" role="columnheader">{{ $t('agreement_no') }}</div>
          <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('event') }}</div>
          <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('start_date') }}</div>
          <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('end_date') }}</div>
          <div class="flex-row flex-row table-header" role="columnheader">{{ $t('hours_changed_to') }}</div>
          <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('status') }}</div>
        </div>
        <div v-if="historyChanges.length > 0">
          <div class="fill-table" :key="index" v-for="(hoursChange, index) in historyChanges">
            <div class="flex-table-history" role="rowgroup" >
      
              <div class="flex-row flex-row-short first" role="cell">        
                {{formatDate(hoursChange.created_at)}}
              </div>
              <div class="flex-row" role="cell">        
                {{hoursChange.user_identity ? `${hoursChange.user_identity.first_name} ${hoursChange.user_identity.last_name}` : ""}}
              </div>
              <div class="flex-row flex-row-long" role="cell">        
                {{`${hoursChange.container_training_agreement.container.name}`}}
              </div>
              <div class="flex-row" role="cell">  
                {{hoursChange.container_training_agreement_id}}  
              </div>
              <div class="flex-row flex-row-short" role="cell">    
                {{$t(hoursChange.event)}}    
              </div>
              <div class="flex-row flex-row-short" role="cell">        
                {{hoursChange.changed_to ? formatDate(hoursChange.changed_to.start_date) : ""}} 
              </div>
              <div class="flex-row flex-row-short" role="cell">        
                {{hoursChange.changed_to ? formatDate(hoursChange.changed_to.end_date) : ""}}
              </div>
              <div class="flex-row" role="cell">        
                {{hoursChange.changed_to ? formatLogbookHours(hoursChange.changed_to.hours) : ''}}
              </div>
              <div class="flex-row flex-row-short" role="cell">     
                <span class="status-bold" v-if="hoursChange.changed_to">
                  {{$t(hoursChange.changed_to.status)}}
                </span>   
                <span v-else>
                  {{""}}
                </span>
              </div>

            </div>

            <div class="flex-table-history" v-if="hoursChange.changed_to && hoursChange.changed_to.comment">
              <div class="flex-row-full" role="cell">
                <span> 
                    {{ `${$t('comment')} : ${hoursChange.changed_to.comment} `}}
                </span>
              </div>
            </div>
          </div>
        </div>


        <div v-else>
          <div class="fill-table">
            <div class="flex-table-history">
                <span class="p-3"> 
                  {{$t('no_history_data')}} 
                </span>
              </div>
            </div>
          </div>
      </div>
    </scroll-shadow>
    <pagination  @items_changed="setItems" :items="hours_changes" :expansion_threshold="expansion_threshold" :pagination_limit="pagination_limit"/>
  </div>
</template>
<script>
import table_top_nav from '../../shared/table_top_nav/TableTopNav.vue';
import Pagination from '../../shared/pagination/Pagination.vue';
import {formatDate, formatLogbookHours} from '../../shared/typescripts/dates.ts'

export default {
  components: { table_top_nav, Pagination},
  
  
  props: ['hours_changes', 'locale', 'active_item', 'pagination_limit', 'expansion_threshold'],
  data() {
      return {
        contentWidth: 0,
        historyChanges: [],
      }},

  methods: {
    //TODO: Revisit to standardize
    // Used for turning our system dates into a standard human readable format
    formatDate(dateString) {
      return formatDate(dateString)
    },

    formatLogbookHours(rowObj) {
      return formatLogbookHours(rowObj)
    },
    
    setItems(items) {
      this.historyChanges = items
    }
  }

}
</script>
